import { FontBold } from '../../utils/editorReactIcons';
export { FontBold };
export default FontBold;
